module.exports = __webpack_public_path__ + "img/flag_chn.399b1ac3.svg";